function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function r() {
  return "ambiki-".concat(Math.random().toString().slice(2, 6));
}

function c(i, t, e) {
  var s = i.indexOf(t);
  s === i.length - 1 && e === 1 && (s = -1);
  var u = e === 1 ? 0 : i.length - 1;

  if (t && s >= 0) {
    var o = s + e;
    o >= 0 && o < i.length && (u = o);
  }

  return i[u];
}

var h = !!navigator.userAgent.match(/Macintosh/),
    a = /*#__PURE__*/function () {
  function a(t, e) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref$isMultiple = _ref.isMultiple,
        s = _ref$isMultiple === void 0 ? !1 : _ref$isMultiple;

    _classCallCheck(this, a);

    this.input = void 0;
    this.list = void 0;
    this.isMultiple = void 0;
    this.isMouseMoving = !1;
    this.input = t, this.list = e, this.isMultiple = s, this.list.id || (this.list.id = r()), this.input.setAttribute("aria-expanded", "false"), this.input.setAttribute("role", "combobox"), this.input.setAttribute("aria-haspopup", "listbox"), this.input.setAttribute("aria-controls", this.list.id), this.input.setAttribute("aria-autocomplete", "list"), this.list.setAttribute("role", "listbox"), this.isMultiple && this.input.setAttribute("aria-multiselectable", "true"), this.onKeydown = this.onKeydown.bind(this), this.onClick = this.onClick.bind(this), this.onListMouseOver = this.onListMouseOver.bind(this), this.onListMouseMove = this.onListMouseMove.bind(this);
  }

  _createClass(a, [{
    key: "start",
    value: function start() {
      this.isMouseMoving = !1, this.input.setAttribute("aria-expanded", "true"), this.setInitialAttributesOnOptions(), this.input.addEventListener("keydown", this.onKeydown), this.list.addEventListener("click", this.onClick), this.list.addEventListener("mouseover", this.onListMouseOver), this.list.addEventListener("mousemove", this.onListMouseMove);
    }
  }, {
    key: "stop",
    value: function stop() {
      this.isMouseMoving = !1, this.clearActiveOption(), this.input.setAttribute("aria-expanded", "false"), this.input.removeEventListener("keydown", this.onKeydown), this.list.removeEventListener("click", this.onClick), this.list.removeEventListener("mouseover", this.onListMouseOver), this.list.removeEventListener("mousemove", this.onListMouseMove);
    }
  }, {
    key: "onKeydown",
    value: function onKeydown(t) {
      if (this.isMouseMoving = !1, !(t.shiftKey || t.metaKey || t.altKey) && !(!h && t.ctrlKey)) switch (t.key) {
        case "Enter":
        case "Tab":
          d(this.list) && t.preventDefault();
          break;

        case "Escape":
          this.clearActiveOption();
          break;

        case "ArrowDown":
          this.move(1), t.preventDefault();
          break;

        case "ArrowUp":
          this.move(-1), t.preventDefault();
          break;

        default:
          break;
      }
    }
  }, {
    key: "onClick",
    value: function onClick(t) {
      var e = l(t.target);
      !e || !n(e) || (this.selectOption(e), e.dispatchEvent(new CustomEvent("combobox:commit", {
        bubbles: !0
      })));
    }
  }, {
    key: "onListMouseOver",
    value: function onListMouseOver(t) {
      if (!this.isMouseMoving) {
        t.preventDefault();
        return;
      }

      var e = l(t.target);
      !e || this.setActive(e, {
        scroll: !1
      });
    }
  }, {
    key: "onListMouseMove",
    value: function onListMouseMove(t) {
      if (this.isMouseMoving) return;
      this.isMouseMoving = !0;
      var e = l(t.target);
      !e || this.setActive(e, {
        scroll: !1
      });
    }
  }, {
    key: "move",
    value: function move(t) {
      var e = c(this.visibleOptions, this.activeOption, t);
      this.setActive(e);
    }
  }, {
    key: "selectOption",
    value: function selectOption(t) {
      if (this.isMultiple) t.setAttribute("aria-selected", (t.getAttribute("aria-selected") !== "true").toString());else {
        var _iterator = _createForOfIteratorHelper(this.options.filter(n)),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var e = _step.value;
            e.setAttribute("aria-selected", (e === t).toString());
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }, {
    key: "setActive",
    value: function setActive(t) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref2$scroll = _ref2.scroll,
          e = _ref2$scroll === void 0 ? !0 : _ref2$scroll;

      if (!t) {
        this.clearActiveOption();
        return;
      }

      var _iterator2 = _createForOfIteratorHelper(this.options),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var s = _step2.value;
          s === t ? (this.input.setAttribute("aria-activedescendant", s.id), s.setAttribute("data-tracking", ""), e && s.scrollIntoView({
            block: "nearest"
          })) : s.removeAttribute("data-tracking");
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "clearActiveOption",
    value: function clearActiveOption() {
      this.input.removeAttribute("aria-activedescendant");

      var _iterator3 = _createForOfIteratorHelper(this.list.querySelectorAll("[data-tracking]")),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var t = _step3.value;
          t.removeAttribute("data-tracking");
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "setInitialAttributesOnOptions",
    value: function setInitialAttributesOnOptions() {
      var _iterator4 = _createForOfIteratorHelper(this.options),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var t = _step4.value;
          t.setAttribute("tabindex", "-1"), n(t) && !t.hasAttribute("aria-selected") && t.setAttribute("aria-selected", "false"), t.id || (t.id = r());
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  }, {
    key: "activeOption",
    get: function get() {
      return Array.from(this.list.querySelectorAll("[data-tracking]"))[0];
    }
  }, {
    key: "visibleOptions",
    get: function get() {
      return this.options.filter(f);
    }
  }, {
    key: "options",
    get: function get() {
      return Array.from(this.list.querySelectorAll('[role="option"]'));
    }
  }]);

  return a;
}();

function d(i) {
  var t = i.querySelector("[data-tracking]");
  return t ? (n(t) && t.click(), !0) : !1;
}

function l(i) {
  if (!(i instanceof HTMLElement)) return !1;
  var t = i.closest('[role="option"]');
  return t instanceof HTMLElement ? t : !1;
}

function f(i) {
  return !i.hidden && !(i instanceof HTMLInputElement && i.type === "hidden") && (i.offsetWidth > 0 || i.offsetHeight > 0);
}

function n(i) {
  return !i.hasAttribute("disabled") && i.getAttribute("aria-disabled") !== "true";
}

export { a as default };